var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"parent",staticClass:"search-input",class:{
    'search-input--wide': _vm.wide,
    'search-input--small': _vm.small
  }},[_c('TextInput',{attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"autofocus":_vm.autofocus},on:{"input":_vm.edit,"keydown":function($event){return _vm.$emit('keydown', $event)}}}),(
      _vm.builderMode === 'breakdance' || (_vm.builderMode === 'oxygen' && !_vm.value)
    )?_c('Icon',{staticClass:"search-input__icon",attrs:{"icon":"SearchIcon","size":_vm.builderMode === 'oxygen' ? 10 : 14}}):_vm._e(),(_vm.value)?_c('Icon',{staticClass:"search-input__clear",attrs:{"icon":"CloseIcon","size":"14"},on:{"click":_vm.clear}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }